"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var initialReducerState = {
    loading: true,
    data: undefined,
    error: undefined
};
exports.default = initialReducerState;
//# sourceMappingURL=initialReducerState.js.map